import { NgModule, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { Directive } from '@angular/core';
import { fromEvent } from 'rxjs';

import Swiper from 'swiper/types/swiper-class';
import type { SwiperOptions } from 'swiper/types/swiper-options';

import { AutoSub, AutoSubOnDestroy } from '../../providers';

// Export the swiper option type for convenience / encapsulation
export type { SwiperOptions, Swiper };

// Register the swiper webcomponent
import { register } from 'swiper/element';
register();

/**
 * Swiper container directive
 */
@Directive({
    selector: 'swiper-container'
})
@AutoSubOnDestroy()
export class SwiperContainerDirective {
    @Input() config: SwiperOptions;
    @Input() disabled: boolean;
    /** Set the current slide index */
    @Input() set index(index: number) {
        this.swiper?.slideTo(index);
    }
    /** Emit the index of the current slide on change */
    @Output() indexChange = new EventEmitter<number>();
    
    public swiper: Swiper;

    constructor(private element: ElementRef<HTMLElement>) {
    }

    ngAfterViewInit(): void {
        // Get the swiper instance from native element
        this.swiper = (this.element.nativeElement as any)?.swiper as Swiper;
        if(!this.swiper) return;
        // Get observable for slide change events
        const changeObs = fromEvent(this.element.nativeElement, "swiperslidechange");
        // Watch slide changes and emit index changed event
        AutoSub(this).reg['watchSwiperChange'] = changeObs.subscribe((ev) => {
            this.indexChange.emit(this.swiper.activeIndex);
        });
    }
}

/**
 * Swiper slide directive
 */
@Directive({
    selector: 'swiper-slide'
})
export class SwiperSlideDirective { }

@NgModule({
    declarations: [
        SwiperContainerDirective,
        SwiperSlideDirective
    ],
    exports: [
        SwiperContainerDirective,
        SwiperSlideDirective
    ]
})
export class SwiperModule { }
